import { Inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';

@Injectable({
    providedIn: 'root',
})
@Pipe({
    name: 'formatDate',
    standalone: false,
})
export class FormatDatePipe implements PipeTransform {
    public constructor(@Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface) {}

    public transform(date: moment.Moment): string {
        const dateFormat = this.clientManager.getDateFormat();
        return date.isValid() ? date.format(dateFormat) : '';
    }
}
